module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "pre1a",
      "src": "images/pre1.jpg"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_c('i', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD")]), _vm._v(" by Trillia J. Newbell")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("1")]), _vm._v(" On the Outside Looking In")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("2")]), _vm._v(" Our Suffering Savior")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("3")]), _vm._v(" Fellowship of the Suffering")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("4")]), _vm._v(" Pleading for Rescue")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("5")]), _vm._v(" Help My Unbelief")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("6")]), _vm._v(" Ambiguous Loss")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("7")]), _vm._v(" Learning to Lament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("8")]), _vm._v(" Finding Rest")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("9")]), _vm._v(" Waiting on Jesus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("10")]), _vm._v(" Fellowship with the Cloud of Witnesses")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("11")]), _vm._v(" Fellowship with the Rock")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCLUSION")])]), _vm._v(": Limping Forward")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")])]), _vm._v(": Offering Companionship to the Suffering")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGGESTED")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADING")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE FOR")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPANIONS IN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UFFERING")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0